import axios from "axios";

export const getEducationLevels = callback => {
  var promise = axios({
    method: "get",
    url: "/api/trabajando_education_levels"
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};
